import type { IconSvgObject } from './types';

const FileBracesIcon: IconSvgObject = [
  ["path", { d: "M20 20V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 12C14.5523 12 15 12.4477 15 13V14C15 14.5523 15.4477 15 16 15C15.4477 15 15 15.4477 15 16V17C15 17.5523 14.5523 18 14 18M10 12C9.44772 12 9 12.4477 9 13V14C9 14.5523 8.55228 15 8 15C8.55228 15 9 15.4477 9 16V17C9 17.5523 9.44772 18 10 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileBracesIcon;
